// extracted by mini-css-extract-plugin
export default {"swipper-container":"styles_swipper-container__whCOr","swipper":"styles_swipper__ivFw9","circle":"styles_circle__UBuVY","active":"styles_active__Zet3s"};